// import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import HomeIcon from "@mui/icons-material/Home"
import LocalPhoneIcon from "@mui/icons-material/LocalPhone"
import EmailIcon from "@mui/icons-material/Email"
import Divider from "@material-ui/core/Divider"
import InstagramIcon from "@mui/icons-material/Instagram"
import FacebookIcon from "@mui/icons-material/Facebook"
import TikTokIcon from "./icon/TiktokIcon"
import { FACEBOOK_LINK, INSTAGRAM_LINK, TIKTOK_LINK, DEFAULT_LANG } from "../constant/constant"
import "../styles/footer.css"
import { Link, useI18next } from "gatsby-plugin-react-i18next"
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { getCurrentLanguageFromURL } from "../util"

const Footer = () => {
	const {languages, originalPath, language} = useI18next();
	
	const {t} = useTranslation();
	
	
	const handleLanguageChange = (event) => {
		const selectedLanguage = event.target.value;
		
		const prefix = process.env.GATSBY_DEV_ENV === 'local' ? '' : '/home';
		
		console.log(prefix, originalPath);
		let path = originalPath.startsWith(`${prefix}/${language}`) ? originalPath.replace(`${prefix}/${language}`, `${prefix}/${selectedLanguage}`) : `${prefix}/${selectedLanguage}${originalPath}`;
		
		// check default language
		if(selectedLanguage === DEFAULT_LANG) {
			path = originalPath;
		}
		
		const isBrowser = typeof window !== "undefined";
		
		if(isBrowser) {
			window.location.href = path; // Redirect to the selected language's URL
			const localStorageKey = 'gatsby-i18next-language';
			window.localStorage.setItem(localStorageKey, selectedLanguage);
		}
		
	};
	
	const [currentLanguage, setCurrentLanguage] = useState('vi');
	useEffect(() => {
		setCurrentLanguage(getCurrentLanguageFromURL());
	}, []);
	
	return (
		<div className="footer-container max-w-screen mx-auto p-10 bg-sectiongreybg">
			<div className="max-w-7xl mx-auto bg-transparent">
				<div className="grid grid-cols-2 xxs:grid-cols-1 lg:grid-cols-2">
					<div>
						<h1 className="text-red text-4xl font-bold">Let's Celebrate</h1>
						<h2 className="text-redTextTitle text-2xl font-bold mt-2">
							{t('Đám cưới công nghệ toàn diện')}
						</h2>
						<ul className="text-xl mt-5">
							<li className='mt-3 flex'>
								<HomeIcon style={{ color: "#D33C29", position: "relative", top: "3px" }}/>
								<h5 className='text-md ml-3 text-redText'>
									{t('Số 9, Ngõ 230, phố Định Công Thượng, phường Định Công, quận Hoàng Mai, Hà Nội')}
								</h5>
							</li>
							{/* <li className='mt-3 flex'>
								<LocalPhoneIcon style={{ color: "#D33C29", position: "relative", top: "3px" }}/>
								<h5 className='text-md ml-3 text-redText'>
									033 997 6706 (Mr. Khanh)
								</h5>
							</li> */}
							<li className='mt-3 flex'>
								<EmailIcon style={{ color: "#D33C29", position: "relative", top: "3px" }}/>
								<h5 className='text-md ml-3 text-redText'>
									letscelebrate.contact.us@gmail.com
								</h5>
							</li>
							<li className='mt-3 flex'>
								<Link to={FACEBOOK_LINK} target="_blank">
									<FacebookIcon style={{ color: "#D33C29", position: "relative", top: "3px" }}/>
								</Link>
								
								<Link to={INSTAGRAM_LINK} target="_blank">
									<InstagramIcon style={{
										color: "#D33C29",
										position: "relative",
										top: "3px",
										marginLeft: "20px"
									}}/>
								</Link>
								
								<Link to={TIKTOK_LINK} target="_blank">
									<div
										style={{ width: "24px", position: "relative", top: "8px", marginLeft: "20px" }}>
										<TikTokIcon color='#D33C29'/>
									</div>
								</Link>
							</li>
							<li className='mt-5 flex'>
								
								<Select
									className='form-outlined-input-container'
									id="attend"
									value={language}
									onChange={handleLanguageChange}
									sx={{height: '40px', width: '40%', color: '#D24527', borderColor: '#D24527'}}
								>
									{languages.map((lng) => (
										<MenuItem value={lng} sx={{color: '#D24527', backgroundColor: '#FFE2DA'}}>
											{currentLanguage === 'vi' ? lng === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh' :
											lng === 'vi' ? 'Vietnamese' : 'English'}
										</MenuItem>
									))}
								</Select>
							</li>
						</ul>
					</div>
					<div className="place-self-end self-center xxs:hidden lg:block">
						<ul className="footer-link text-xl font-bold mt-10">
							{/* <li className='mt-4'>
								<Link to="/" className='text-redTextTitle'>{t("Trang chủ")}</Link>
							</li> */}
							<li className='mt-4'>
								<Link to="/about" className='text-redTextTitle'>{t("Về chúng tôi")}</Link>
							</li>
							{/* <li className='mt-4'>
								<Link to="/wedding-invitation"
								      className='text-redTextTitle'>{t("Thiệp mời cưới")}</Link>
							</li> */}
							<li className='mt-4'>
								<Link to="/pricing" className='text-redTextTitle'>{t("Bảng giá")}</Link>
							</li>
							<li className='mt-4'>
								<Link to="/privacy" className='text-redTextTitle'>{t("Chính sách bảo mật")}</Link>
							</li>
							<li className='mt-4'>
								<Link to="/termOfService" className='text-redTextTitle'>{t("Điều khoản dịch vụ")}</Link>
							</li>
							<li className='mt-4'>
								<Link to="https://article.letscelebrate.vn/" className='text-redTextTitle'>{t("Blog")}</Link>
							</li>
						</ul>
					</div>
				</div>
				<div className="grid grid-cols-1 xxs:grid-cols-1 lg:grid-cols-1">
					<Divider style={{ marginTop: "20px" }}/>
					<h1 className="footer-link text-redText text-lg mt-5 flex justify-center">
						© Copyright{" "}&nbsp;<a className='text-md ml-3 text-redText' href="">LetK JSC</a>
					</h1>
				</div>
			</div>
		</div>
	)
}

export default Footer
